import type { FC } from "react";
import React from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import {
  Body,
  Box,
  Popover,
  TicketSeparator,
} from "@edreamsodigeo/prisma-design-system";

import { LightboxPopoverList } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/components/LightboxPopoverList";
import type { LightBoxFooterPopoverProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/contracts";

export const LightboxFooterPopover: FC<LightBoxFooterPopoverProps> = ({
  isHowPrimeOpen,
  freeTrialDays,
}) => {
  const { t } = useTranslation();
  return (
    <Popover
      open={isHowPrimeOpen}
      placement={"top"}
      size={"compact"}
      align={"middle"}
    >
      <Box p={"base"}>
        <Body type={"small"} weight={"medium"}>
          {t("lightboxPrimeRevampDesktop.popup.title")}
        </Body>
      </Box>
      <TicketSeparator orientation={"horizontal"} type={"solid"} />
      <Box p={"base"}>
        <LightboxPopoverList freeTrialDays={freeTrialDays} />
      </Box>
    </Popover>
  );
};
